import helper from "actions/helper";

export default function ReportDaily(date, slotsOnDay) {

    const style = [{
        name: "wrapText",
        start: [1, 1],
        end: [1, 1]
    }, {
        name: "border",
        start: [5, 1],
        end: [5, 3]
    }, {
        name: "bold",
        start: [1, 1],
        end: [1, 5]
    }, {
        name: "bold",
        start: [2, 1],
        end: [2, 5]
    }];

    const width = [{ key: 'A', width: 15 }];

    const merges = [
        { start: [1, 1], end: [1, 6] },
        { start: [2, 1], end: [2, 6] },
    ];

    const period = helper.date.getWeekString(date);

    let text = [
        [`Расписание за ${period} г.`],
        [`Отчет сформирован ${helper.date.toStr(new Date(), "DD MMMM YYYY")} г. в ${helper.date.toStr(new Date(), "HH mm")}`],
        ["", "", "", ""],
        ["", "", "", ""]
    ];

    const header = [""];
    let s = 0;

    const getColumnLetter = (index) => {
        let letter = "";
        while (index > 0) {
            const mod = (index - 1) % 26;
            letter = String.fromCharCode(65 + mod) + letter;
            index = Math.floor((index - 1) / 26);
        }
        return letter;
    };

    slotsOnDay.forEach((it, i) => {
        if (it.some(cabinet => cabinet?.data)) {
            header.push(it[0].title);
            header.push("");
            const column = 2 + 2 * i;

            merges.push({
                start: [5, column],
                end: [5, column + 1]
            });
            s += 2;
            width.push({ key: getColumnLetter(column), width: 15 });
            width.push({ key: getColumnLetter(column + 1), width: 23 });
        }
    });

    style.push({ name: "border", start: [5, 1], end: [5, s] });
    style.push({ name: "bold", start: [5, 1], end: [5, s] });

    const getInterval = ({ beginDate, endDate }) => {
        return `${helper.date.toStr(beginDate, "HH:mm")} - ${helper.date.toStr(endDate, "HH:mm")}`;
    };

    const getDoctor = (it) => {
        return helper.string.formatFullName(globalThis.appPageView.getDoctorById(it), "short");
    };

    const dataRow = [];
    slotsOnDay[0].forEach((dt, ind) => {
        const row1 = [];
        const row2 = [];
        const row3 = [];
        const row4 = [];
        row1.push(helper.string.capitalize(helper.date.toStr(dt.date, "DD.MM")));
        row2.push(helper.date.toStr(dt.date, "dd"));

        slotsOnDay.forEach(cabinet => {
            const exist = cabinet[ind].data?.sort((a, b) => new Date(a.beginDate) - new Date(b.beginDate));
            row1.push(exist?.length > 0 ? getInterval(exist[0]) : "");
            row1.push(exist?.length > 0 ? getDoctor(exist[0].doctorId) : "");
            row2.push(exist?.length > 1 ? getInterval(exist[1]) : "");
            row2.push(exist?.length > 1 ? getDoctor(exist[1].doctorId) : "");
            row3.push(exist?.length > 2 ? getInterval(exist[2]) : "");
            row3.push(exist?.length > 2 ? getDoctor(exist[2].doctorId) : "");
            row3.push(exist?.length > 3 ? getInterval(exist[3]) : "");
            row3.push(exist?.length > 3 ? getDoctor(exist[3].doctorId) : "");

        });

        dataRow.push(row1);
        dataRow.push(row2);
        dataRow.push(row3);
        dataRow.push(row4);
    });

    style.push({ name: "border", start: [6, 1], end: [dataRow.length + 4, s + 1] });

    text.push(header);
    text = [
        ...text,
        ...dataRow
    ];

    /*intervalText.forEach(it => {
        text.push([it.name]);
        text.push([it.dt]);
        text.push([""]);
        text.push([""]);
    });*/

    const data = { text, style, width, merges };
    helper.xlsx.exportToExcel(data, "ReportDaily.xlsx");
}
